<p class="ao-margin-note">
  Test only for {{ vendorName || 'this vendor' }}. Nothing here changes past sales or existing frame prices.
</p>

<div class="ao-margin-inputs">
  <label>
    <span>Invoice currency</span>
    <select [(ngModel)]="currency" (ngModelChange)="onCurrencyChange()">
      <option *ngFor="let code of currencies" [value]="code">{{ code }}</option>
    </select>
  </label>
  <label>
    <span>Frame cost — {{ symbol }}</span>
    <input type="number" min="0" step="0.01" [(ngModel)]="foreignCost">
  </label>
  <label>
    <span>USD rate · 1 {{ currency }} = $</span>
    <input type="number" min="0" step="0.0001" [(ngModel)]="exchangeRate">
  </label>
  <label>
    <span>Shipping — {{ symbol }}</span>
    <input type="number" min="0" step="0.01" [(ngModel)]="shipping">
  </label>
  <label>
    <span>Tax / duty — {{ symbol }}</span>
    <input type="number" min="0" step="0.01" [(ngModel)]="duty">
  </label>
</div>

<div class="ao-margin-formula">
  <div><b>Converted frame</b><strong>{{ convertedCost | currency }}</strong></div>
  <span>+</span>
  <div><b>Shipping</b><strong>{{ convertedShipping | currency }}</strong></div>
  <span>+</span>
  <div><b>Tax / duty</b><strong>{{ convertedDuty | currency }}</strong></div>
  <span>=</span>
  <div><b>Landed cost</b><strong>{{ landed | currency }}</strong></div>
</div>

<div class="ao-margin-controls">
  <label>
    <span>Cost multiple</span>
    <input type="number" min="0" step="0.1" [(ngModel)]="multiple">
  </label>
  <label>
    <span>Proposed retail</span>
    <input type="number" min="0" step="1" [ngModel]="proposedRetail" (ngModelChange)="onRetailChange($event)">
  </label>
</div>

<div class="ao-margin-signal" [class.red]="signal === 'red'" [class.yellow]="signal === 'yellow'" [class.green]="signal === 'green'">
  <span>{{ signalLabel }}</span>
  <small>Provisional floor 60% · target 66.7%</small>
</div>

<table class="ao-margin-results">
  <thead>
    <tr>
      <th>Scenario</th>
      <th>Landed cost</th>
      <th>Proposed retail</th>
      <th>Gross profit</th>
      <th>Gross margin</th>
      <th>Cost multiple</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Test</td>
      <td>{{ landed | currency }}</td>
      <td>{{ proposedRetail | currency }}</td>
      <td>{{ grossProfit | currency }}</td>
      <td>{{ marginPercent | number:'1.1-1' }}%</td>
      <td>{{ multiple | number:'1.2-2' }}×</td>
    </tr>
  </tbody>
</table>
